
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24.967","height":"25"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M13.27.007c.465.066.93.118 1.4.192a12.484 12.484 0 019.866 8.98c.118.458.214.916.3 1.381.066.384.1.775.14 1.182h-3.421A9.118 9.118 0 008.61 4.284c-.561-.975-1.13-1.957-1.735-3.005C7.613 1.013 8.3.696 9.024.511c.82-.214 1.669-.31 2.511-.465l.185-.044c.516.005 1.033.005 1.55.005zM.007 11.712c.066-.48.111-.967.2-1.44a12.377 12.377 0 015.28-8.108.5.5 0 01.081-.052.3.3 0 01.074-.015q.842 1.451 1.691 2.924a9.111 9.111 0 000 14.946c-.561.975-1.122 1.95-1.713 2.969-.354-.266-.709-.51-1.034-.775a12.4 12.4 0 01-4.475-7.99c-.044-.3-.074-.591-.111-.894.007-.524.007-1.048.007-1.565zM6.875 23.682c.6-1.034 1.159-2.009 1.721-2.983a9.113 9.113 0 0012.945-7.459h3.426a12.17 12.17 0 01-5.516 9.6c-3.988 2.651-8.204 2.776-12.576.842z"}}),_c('path',{staticClass:"a",attrs:{"d":"M12.502 4.881a7.606 7.606 0 107.6 7.628 7.622 7.622 0 00-7.6-7.628zM9.659 15.633a.719.719 0 01-.982.7.732.732 0 01-.473-.724c-.007-.3 0-.6 0-.894V9.354a.74.74 0 01.709-.842.708.708 0 01.746.768c.007.894 0 1.794 0 2.688v.487c0 1.058.008 2.114 0 3.178zm2.555-.03a.742.742 0 01-.576.768.711.711 0 01-.8-.4 1.034 1.034 0 01-.074-.4c-.007-.775 0-1.551 0-2.326v-2.356a.73.73 0 111.455-.015c.003 1.569.003 3.149-.005 4.729zm2.444-3.19v3.2a.717.717 0 01-1.314.4.916.916 0 01-.133-.458 953.421 953.421 0 010-6.328.728.728 0 111.455 0c-.008 1.067-.008 2.13-.008 3.186zm2.415 3.146a.729.729 0 11-1.455-.015v-3.057a.728.728 0 111.455-.015c.009 1.041.009 2.06 0 3.087z"}})])
          )
        }
      }
    